<template>
  <div class="leads-web-index">
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t('menu.leads-web'), disabled: true },
        { title: this.$t('menu.leads-web/dashboard'), disabled: true },

      ]">

      <div v-if="selectedFlow" slot="breadcrumbAfter" class="d-flex align-items-center">

        <Searchable class="mr-2" :querySearch.sync="filters.querySearch"/>

        <Filters
          :isActive="showFilters"
          :activeFilters="countActiveFilters"
          @toggle-filters="toggleFilters"/>

      </div>

    </Breadcrumbs>

    <br/>
    <div>
      <div class="col-12">
        <label class="form-label">
          {{ $t('leads-web.filters.flow') }}
        </label>
        <multiselect
          id="flow-multiselect"
          v-model="selectedFlow"
          :options="flowOptions"
          track-by="id"
          label="name"
          :placeholder="$t('leads-web.filters.flow')"
          :allow-empty="true"
          :multiple="false"
        >
          <template slot="clear">
                            <span class="multiselect__clear" v-if="selectedFlow !== null"
                                  @mousedown.prevent.stop="selectedFlow = null"></span>
          </template>
        </multiselect>
      </div>
    </div>
    <div v-if="selectedFlow">

      <div class="evollu-form row" v-if="showFilters">

        <div class="col-12 col-sm-6 col-md-3">
          <label class="form-label">{{ $t('leads-web.filters.scheduled-time') }}</label>
          <range-date-picker
            id="leads-web-date-range"
            v-model="filters.dateRange"
            placeholder="---"
            :clearable="false"
          >
          </range-date-picker>
        </div>

        <div class="col-12 col-sm-6 col-md-3">
          <label class="form-label">
            {{ $t('leads-web.filters.suppliers') }}
          </label>
          <multiselect
            id="suppliers-multiselect"
            v-model="filters.suppliers"
            :options="leadSuppliers"
            track-by="id"
            label="name"
            placeholder="---"
            :allow-empty="true"
            :multiple="true"
          >
            <template slot="clear">
                            <span class="multiselect__clear" v-if="filters.suppliers.length > 0"
                                  @mousedown.prevent.stop="filters.suppliers = []"></span>
            </template>
          </multiselect>
        </div>

        <div class="col-12 col-sm-6 col-md-3">
          <label class="form-label">
            {{ $t('leads-web.filters.input-sources') }}
          </label>
          <multiselect
            id="sources-multiselect"
            v-model="filters.sources"
            :options="leadSources"
            track-by="name"
            label="name"
            placeholder="---"
            :allow-empty="true"
            :multiple="true"
          >
            <template slot="clear">
                            <span class="multiselect__clear" v-if="filters.sources.length > 0"
                                  @mousedown.prevent.stop="filters.sources = []"></span>
            </template>
          </multiselect>
        </div>

        <div class="col-12 col-sm-6 col-md-3">
          <label class="form-label">
            {{ $t('leads-web.filters.customer-entities') }}
          </label>
          <multiselect
            id="client-multiselect"
            v-model="filters.clients"
            :options="leadClients"
            track-by="id"
            label="name"
            placeholder="---"
            :allow-empty="true"
            :multiple="true"
          >
            <template slot="clear">
                            <span class="multiselect__clear" v-if="filters.clients.length > 0"
                                  @mousedown.prevent.stop="filters.clients = []"></span>
            </template>
          </multiselect>
        </div>

      </div>

      <div class="col-12 mt-3">
        <div class="rectangle_total">
          <span class="text--bold">TOTAL  <i class="fa fa-user"></i> </span>
          &nbsp;
          <span>{{ leads.length ? leads.length : 0 }} leads</span>
        </div>
      </div>

      <DraggableTable
        :canEdit="canEdit"
        :readEntities="readEntities"
        :writableEntities="writableEntities"
        :leads="leads"
        :list="list"
        :suppliers="leadSuppliers"
        @lead-updated="handleLeadUpdated"
        :key="componentKey"
        :showFilters.sync="showFilters"
        @filters-updated="onFiltersUpdated"/>
    </div>

  </div>
</template>

<script>

import Breadcrumbs from '@/components/common/Breadcrumbs'
import StateMachine from '@/components/leads-web/state-machines/StateMachine'
import {LeadsWebService} from '@/api/LeadsWebService'
import LoadingAnimation from '@/components/users/components/Helpers/LoadingAnimation'
import DraggableTable from '@/components/leads-web/dashboard/DraggableTable'
import {mapState} from 'vuex'
import RangeDatePicker from '@/components/common/RangeDatePicker'
import Multiselect from 'vue-multiselect'
import Searchable from '@/components/common/Searchable'
import Filters from '@/components/common/Filters'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
import {FILTERS_LEADS_WEB} from '@/local-storage/LocalStorageKeys'

const NOT_CONFIRMED_LEAD_STATUS = 2
const LEADS_WEB_INFO_TYPE = 200
const COLUMN_TYPE_ACTION = 'action'
const COLUMN_TYPE_STATUS = 'status'

export default {
  components: {
    LoadingAnimation,
    StateMachine,
    Breadcrumbs,
    DraggableTable,
    RangeDatePicker,
    Multiselect,
    Searchable,
    Filters,
  },
  data() {
    return {
      isLoading: false,
      leadActions: [],
      leads: [],
      list: [],
      leadSuppliers: [],
      selectedSuppliersIds: '',
      leadSources: [],
      selectedSources: '',
      leadClients: [],
      selectedClientIds: '',
      selectedFlow: null,
      flowOptions: [],
      filters: {
        dateRange: {
          start: this.moment().subtract(1, 'months').format('YYYY-MM-DD'),
          end: this.moment().format('YYYY-MM-DD')
        },
        suppliers: [],
        sources: [],
        clients: [],
        querySearch: '',
      },
      showFilters: false,
      activeFilters: 0,
      componentKey: 0,
      reloadInterval: null,
      poolingInterval: null,
    }
  },
  mounted() {
    this.getFlows()
      .then(() => this.getFiltersData()
        .then(() => this.loadLocalStorage()))
    this.onFiltersUpdated(this.countActiveFilters)

    /*this.$nextTick(function () {
      this.reloadInterval = setInterval(() => {
        this.getData()
      }, 10000)
    })*/
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.reloadInterval)
    next()
  },
  methods: {
    getFlows: function () {
      return new Promise((resolve, reject) => {
        LeadsWebService.getFlows().then(res => {
          this.flowOptions = res
          resolve()
        }).catch((err)=> {reject(err)})
      })
    },
    getFiltersData: function () {
      return new Promise((resolve, reject) => {
        LeadsWebService.getLeadSuppliers().then(res => {
          this.leadSuppliers = res
          LeadsWebService.getLeadSources().then(res => {
            this.leadSources = res.filter(s => s.name !== null)
            LeadsWebService.getLeadClientIds().then(res => {
              const entitiesIds = res.filter(elem => elem.id !== null).map(elem => elem.id)
              if (this.canEdit) {
                this.leadClients = this.writableEntities.filter(entity => entitiesIds.some(item => entity.id === item))
              } else {
                this.leadClients = this.readEntities.filter(entity => entitiesIds.some(item => entity.id === item))
              }
              resolve()
            })
          })
        })
      })
    },
    rerenderComponent() {
      this.componentKey += 1
    },
    handleLeadUpdated: function (lead) {
      this.getData()
      // this.rerenderComponent()
    },
    getData: function () {
      if (this.selectedFlow) {
        this.isLoading = true
        LeadsWebService.getContactActions(this.selectedFlow.id).then(res => {
          this.leadActions = res
          this.leadActions.forEach((elem) => elem.type = COLUMN_TYPE_ACTION)
          this.leadActions.sort((a, b) => (a.display_order > b.display_order) ? 1 : ((b.display_order > a.display_order) ? -1 : 0))
          this.getLeads()
        }).catch(err => {
          this.showToast(this.$t('leads-web.actions.fetch-error'), this.$store.state.errorToastOptions)
          console.log(err)
          this.isLoading = false
        })
      }
    },
    getLeads: function () {
      LeadsWebService.getLeads({
        params: {
          start: this.filters.dateRange.start,
          end: this.moment(this.filters.dateRange.end).add(1, 'days').format('YYYY-MM-DD'),
          suppliers: this.selectedSuppliersIds,
          sources: this.selectedSources,
          clients: this.selectedClientIds,
          querySearch: this.filters.querySearch
        }
      })
        .then(res => {
          this.leads = res
          this.leads = this.leads.filter(lead => lead.flowId === this.selectedFlow.id || lead.clientId === this.selectedFlow.clientId)
          this.generateList()
        }).catch(err => {
        this.showToast(this.$t('leads-web.leads.fetch-error'), this.$store.state.errorToastOptions)
        console.log(err)
        this.isLoading = false
      })
    },
    generateList: function () {
      // this.leadActions = this.leadActions.map(obj => ({ ...obj, type: COLUMN_TYPE_ACTION }))
      this.list = []
      this.list.push(...this.leadActions)
      this.list.push(...this.leadStatuses)
      let count = 1
      for (let item of this.list) {
        item.list_id = count
        item.leads = []
        if (item.type === COLUMN_TYPE_ACTION) {
          item.leads = this.leads.filter(lead => lead.status.id === NOT_CONFIRMED_LEAD_STATUS && lead.lastContactAction && lead.lastContactAction.id === item.id)
        }
        if (item.type === COLUMN_TYPE_STATUS) {
          item.leads = this.leads.filter(lead => lead.status.id !== NOT_CONFIRMED_LEAD_STATUS && lead.status.id === item.id)
        }
        ++count
      }

      this.isLoading = false
    },
    onFiltersUpdated: function (activeFilters) {
      this.activeFilters = activeFilters
      if (activeFilters > 0) this.showFilters = true
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    loadLocalStorage: function () {
      return new Promise((resolve, reject) => {
        const state = LocalStorageHelper.get(FILTERS_LEADS_WEB)
        if (state) {
          if (state.selectedSuppliersIds !== '') {
            this.filters.suppliers = this.leadSuppliers.filter(s => state.selectedSuppliersIds.includes(s.id))
          }

          if (state.selectedClientIds !== '') {
            this.filters.clients = this.leadClients.filter(c => state.selectedClientIds.includes(c.id))
          }

          if (state.selectedSources !== '') {
            this.filters.sources = this.leadSources.filter(s => state.selectedSources.includes(s.name))
          }

          if (state.querySearch !== '') {
            this.filters.querySearch = state.querySearch
          }

          if (state.dateRange && state.dateRange.start && state.dateRange.start !== '' && state.dateRange.end && state.dateRange.end !== '') {
            this.filters.dateRange.start = state.dateRange.start
            this.filters.dateRange.end = state.dateRange.end
          }
        }

        this.hasLoadedLocalStorage = true

        resolve()
      })
    },
    saveLocalStorage: function () {
      LocalStorageHelper.set(FILTERS_LEADS_WEB, {
        dateRange: this.filters.dateRange,
        selectedSuppliersIds: this.selectedSuppliersIds,
        selectedSources: this.selectedSources,
        selectedClientIds: this.selectedClientIds,
        querySearch: this.filters.querySearch
      })
    }
  },
  computed: {
    ...mapState({
      'leadStatuses': (state) => state.leadsWeb.leadStatuses,
      'leadsWebToken': (state) => state.leadsWeb.leadsWebSrvToken,
    }),
    audiologyService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollead_server)
    },
    writableEntities: function () {
      let leadsWebPermissions = this.audiologyService.user_permissions.filter(permission => permission.access_type >= 2 && permission.info_type === LEADS_WEB_INFO_TYPE)
      if (leadsWebPermissions.length > 0) {
        if (leadsWebPermissions.some(permission => permission.entity_id === null)) {
          return [...this.audiologyService.entities]
        } else {
          return leadsWebPermissions.map(permission => this.audiologyService.entities.find(entity => permission.entity_id === entity.id)).filter(v => v)
        }
      } else {
        return []
      }
    },
    readEntities: function () {
      let leadsWebPermissions = this.audiologyService.user_permissions.filter(permission => permission.access_type >= 1 && permission.info_type === LEADS_WEB_INFO_TYPE)
      if (leadsWebPermissions.length > 0) {
        if (leadsWebPermissions.some(permission => permission.entity_id === null)) {
          return [...this.audiologyService.entities]
        } else {
          return leadsWebPermissions.map(permission => this.audiologyService.entities.find(entity => permission.entity_id === entity.id)).filter(v => v)
        }
      } else {
        return []
      }
    },
    permissions: function () {
      if (this.audiologyService) {
        return this.audiologyService.user_permissions
      }
      return null
    },
    canEdit() {
      if (this.permissions.length) {
        return this.permissions.some(perm => perm.access_type >= 2 && perm.info_type === LEADS_WEB_INFO_TYPE)
      }
      return false
    },
    countActiveFilters: function () {
      let count = 0
      if (this.filters.suppliers.length > 0) count++
      if (this.filters.sources.length > 0) count++
      if (this.filters.clients.length > 0) count++
      return count
    },
  },
  watch: {
    'selectedFlow': function (flow) {
      if (flow) {
        this.getData()
      } else if(this.reloadInterval) {
        clearInterval(this.reloadInterval)
      }

    },
    'filters.dateRange': function () {
      if (this.hasLoadedLocalStorage) {
        this.getData()
      }

      this.saveLocalStorage()
    },
    'filters.suppliers': function (values) {
      this.selectedSuppliersIds = values.map(s => s.id).join(',')

      if (this.hasLoadedLocalStorage) {
        this.getData()
      }

      this.saveLocalStorage()
    },
    'filters.sources': function (values) {
      this.selectedSources = values.map(s => s.name).join(',')
      if (this.hasLoadedLocalStorage) {
        this.getData()
      }

      this.saveLocalStorage()
    },
    'filters.clients': function (values) {
      this.selectedClientIds = values.map(c => c.id).join(',')
      if (this.hasLoadedLocalStorage) {
        this.getData()
      }
      this.saveLocalStorage()
    },
    'filters.querySearch': function (value) {
      if (value.length > 2 || value.length === 0) {
        if (this.hasLoadedLocalStorage) {
          this.getData()
        }
        this.saveLocalStorage()
      }
    },
  }
}

</script>

<style lang="scss">
.rectangle_total {
  margin: auto;
  height: 40px;
  width: 200px;
  background-color: rgb(63, 64, 64);
  border-radius: 50px;
  color: white;
  text-align: center;
  padding: 7px;
}
</style>
